"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function getSize(node) {
    var rect = node.getBoundingClientRect();
    if (rect.width > 450) {
        return 'large';
    }
    else if (rect.width > 300) {
        return 'medium';
    }
    else {
        return 'small';
    }
}
function useSize() {
    var _a = react_1.useState('small'), size = _a[0], setSize = _a[1];
    var _b = react_1.useState(null), node = _b[0], setNode = _b[1];
    var ref = react_1.useCallback(function (node) {
        setNode(node);
    }, []);
    react_1.useLayoutEffect(function () {
        if (node) {
            var measure_1 = function () {
                return window.requestAnimationFrame(function () { return setSize(getSize(node)); });
            };
            measure_1();
            window.addEventListener('resize', measure_1);
            return function () {
                window.removeEventListener('resize', measure_1);
            };
        }
        return function () { };
    }, [node]);
    return [ref, size, node];
}
exports.default = useSize;
